import React from 'react';
import styled from 'styled-components';

const ConfirmScreenOneStyle = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 150px;
	.start {
		text-align: center;
		margin-bottom: 20px;
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		height: 200px;
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		height: 300px;
	}
`;

export const ConfirmScreenOne = ({ share }) => {
	return (
		<ConfirmScreenOneStyle>
			<div className='start body10'>
				{`You are requesting to permanently delete ${share?.common_name}.This cannot be undone. Are you sure
				you want to proceed?`}
			</div>
			<div className='conntinue labels21'>Click to continue to next screen</div>
		</ConfirmScreenOneStyle>
	);
};
